import { RegisterForm } from '../../../components/forms';

export const Register = () => {
  return (
    <div className="columns">
      <RegisterForm />
    </div>
  );
};
